var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"legend-item"},[_c('span',{staticClass:"legend-icon",style:({ background: _vm.color })}),_c('span',{staticClass:"legend-name"},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }